import { useEventContext } from '../../../hooks/contexts/event.context';
import { useI18nContext } from '../../../hooks/contexts/i18n.context';
import * as Styles from './styles.loader';

const LoaderMember = () => {
  const { translate } = useI18nContext();
  const { membershipApplied } = useEventContext();
  return (
    <Styles.Wrapper id="loader-member-wrapper">
      <Styles.Spinner viewBox="0 0 50 50" id="loader-member-spinner">
        <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5" id="loader-member-circle"/>
      </Styles.Spinner>
      {!membershipApplied && (
        <Styles.TextInfo id="loader-member-text">{translate(['INFORMATION', 'CHECKING_DOCUMENT'])}</Styles.TextInfo>
      )}
    </Styles.Wrapper>
  );
};

export default LoaderMember;
